export enum MessageTypes {
    ERROR = 'error',
    SUCCESS = 'success'
}